// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import defaultImage from "../../../assets/img/default.png";
import { RenderIf } from '../../utils/RenderIf';
import { CouponPosFetchAPI } from '../../../api/Coupon';
import SuccessAlert from '../../Alerts/SuccessAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import './cupon.css';


/* ── ICONS ── */
const IcoTicket = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z"/></svg>;
const IcoX      = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoBack   = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>;
const IcoNext   = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6"/></svg>;
const IcoSave   = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoCheckG = ()=><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoPlus   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoInfo   = ()=><span style={{fontSize:'.6rem',fontWeight:700,lineHeight:1}}>?</span>;

/* ── Tooltip info ── */
const Info = ({ tip }) => (
  <div className="mcc-info-wrap">
    <div className="mcc-info-btn"><IcoInfo /></div>
    <div className="mcc-tooltip">{tip}</div>
  </div>
);

/* ════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════ */
const ModalCreateCupon = ({ user, token, combos, groups, setEventHandler }) => {



  /* ══════════════════════════════════════════════════════
  ══════════════════════════════════════════════════════ */
  const [showModal, setShowModal]                   = useState(false);
  const [imgpreview, setImgPreview]                 = useState(defaultImage);
  const [cuponType, setCuponType]                   = useState('ORDER');
  const [showDateLimit, setShowDateLimit]           = useState(false);
  const [showSpecificHours, setShowSpecificHours]   = useState(false);
  const [showSpecificDays, setShowSpecificDays]     = useState(false);
  const [selectedDays, setSelectedDays]             = useState([]);
  const [discount_type, setDiscountType]            = useState('PERCENTAGE');
  const [hasUsageLimit, setHasUsageLimit]           = useState(false);
  const [usageLimit, setUsageLimit]                 = useState('');
  const [needsUniqueCodes, setNeedsUniqueCodes]     = useState(false);
  const [uniqueCodeQuantity, setUniqueCodeQuantity] = useState('');
  const [selectedProducts, setSelectedProducts]     = useState([]);
  const fileInputRef                                = useRef(null);
  const [discountValue, setDiscountValue]           = useState('');
  const [maxDiscount, setMaxDiscount]               = useState('');
  const [minOrderValue, setMinOrderValue]           = useState('');
  const [description, setDescription]               = useState('');
  const [couponName, setCouponName]                 = useState('');
  const [initialHour, setInitialHour]               = useState('');
  const [expirationHour, setExpirationHour]         = useState('');
  const [expirationDate, setExpirationDate]         = useState('');

  const handleClick = () => { fileInputRef.current.click(); };

  const changeImage = (e) => { setImgPreview(URL.createObjectURL(e.target.files[0])); };

  const handleDaySelection = (day) => {
    setSelectedDays((prevDays) =>
      prevDays.includes(day) ? prevDays.filter(d => d !== day) : [...prevDays, day]
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (fileInputRef.current.files[0]) {
      formData.append('files', fileInputRef.current.files[0]);
    }
    const couponData = {
      name: couponName,
      type: cuponType,
      business_id: user.business_id,
      is_general: needsUniqueCodes ? 1 : 0,
      discount_type: discount_type,
      discount_value: discountValue,
      description: description,
      min_order_value: cuponType === "ORDER" ? minOrderValue : null,
      max_discount: cuponType === "ORDER" ? maxDiscount : null,
      products: selectedProducts.map(product => ({
        product_id: product.product_id,
        is_combo: product.is_combo
      })),
      conditions: [],
    };
    if (showSpecificDays) {
      selectedDays.forEach(day => { couponData.conditions.push({ type: 'DAY', value: day }); });
    }
    if (usageLimit !== undefined && usageLimit !== '' && usageLimit !== 0 || null) {
      couponData.usage_limit = usageLimit;
    } else {
      couponData.usage_limit = 0;
    }
    if (uniqueCodeQuantity !== undefined && uniqueCodeQuantity !== 0 && uniqueCodeQuantity !== '' || null) {
      couponData.code_count = uniqueCodeQuantity;
    } else {
      couponData.code_count = 0;
    }
    if (showSpecificHours) {
      couponData.conditions.push({ type: 'TIME', value: `${initialHour} - ${expirationHour}` });
    }
    if (showDateLimit) {
      couponData.conditions.push({ type: 'expiration_date', value: expirationDate });
    }
    if (couponData.min_order_value) {
      couponData.conditions.push({ type: 'min_order_value', value: couponData.min_order_value });
    }
    if (couponData.max_discount) {
      couponData.conditions.push({ type: 'max_discount', value: couponData.max_discount });
    }
    formData.append("name", couponName);
    setCouponName(couponData.name);
    formData.append("type", couponData.type);
    formData.append("business_id", couponData.business_id);
    formData.append("is_general", couponData.is_general);
    formData.append("discount_type", couponData.discount_type);
    formData.append("discount_value", couponData.discount_value);
    formData.append("description", couponData.description);
    formData.append("products", JSON.stringify(couponData.products));
    formData.append("conditions", JSON.stringify(couponData.conditions));
    formData.append("usage_limit", couponData.usage_limit);
    formData.append("code_count", couponData.code_count);
    formData.append("min_order_value", couponData.min_order_value);
    formData.append("max_discount", couponData.max_discount);

    try {
      await CouponPosFetchAPI.newCupon(formData, token);
      SuccessAlert("Cupón creado exitosamente");
      setEventHandler(1);
      setSuccess(true); // mostrar pantalla de éxito dentro del modal
    } catch (err) {
      console.error(err);
      ErrorAlert("Error al crear el cupón", "Inténtalo de nuevo", "error");
    }
  };

  const [step, setStep]   = useState(1);
  const totalSteps        = 7;

  const nextStep = () => { if (step < totalSteps) setStep(step + 1); };
  const prevStep = () => { if (step > 1) setStep(step - 1); };

  useEffect(() => { if (!showModal) { setStep(1); } }, [showModal]);
  /* ══════════════════════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ══════════════════════════════════════════════════════ */

  /* ── estado adicional para pantalla de éxito ── */
  const [success, setSuccess] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setImgPreview(defaultImage);
    setSelectedProducts([]);
    setDiscountType("PERCENTAGE");
    setSuccess(false);
  };

  /* step labels para el stepper */
  const STEP_LABELS = ['Imagen', 'Tipo', 'Descuento', 'Valores', 'Fechas', 'Días', 'Códigos'];

  /* ══════════════════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════════════════ */
  return (
    <>
      {/* ── TRIGGER ── */}
      <button className="mcc-trigger" onClick={() => setShowModal(true)}>
        <IcoPlus /> Crear Cupón
      </button>

      {/* ── Bootstrap Modal (importación original) ── */}
      <Modal
        show={showModal}
        backdrop="static"
        onHide={handleClose}
        size="lg"
        centered
        dialogClassName="mcc-dialog"
      >
        <Modal.Body className="position-relative">

          {/* ── HEADER personalizado ── */}
          <div className="mcc-header">
            <div className="mcc-header-icon"><IcoTicket /></div>
            <div className="mcc-header-info">
              <div className="mcc-header-title">Crear Cupón</div>
              <div className="mcc-header-sub">
                {success ? 'Cupón creado exitosamente' : `Paso ${step} de ${totalSteps} — ${STEP_LABELS[step - 1]}`}
              </div>
            </div>
            <button className="mcc-header-close" type="button" onClick={handleClose}><IcoX /></button>
          </div>

          {/* ── STEPPER ── */}
          {!success && (
            <div className="mcc-stepper">
              {STEP_LABELS.map((label, i) => (
                <React.Fragment key={i}>
                  <div className="mcc-step-node">
                    <div className={`mcc-step-circle${step === i+1 ? ' active' : step > i+1 ? ' done' : ''}`}>
                      {step > i+1
                        ? <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                        : <span>{i+1}</span>
                      }
                    </div>
                  </div>
                  {i < STEP_LABELS.length - 1 && (
                    <div className={`mcc-step-connector${step > i+1 ? ' done' : ''}`} />
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* ── PANTALLA ÉXITO ── */}
          {success && (
            <div className="mcc-success">
              <div className="mcc-success-ring"><IcoCheckG /></div>
              <div className="mcc-success-title">¡Cupón creado exitosamente!</div>
              <div className="mcc-success-sub">
                Tu cupón <strong>{couponName}</strong> fue registrado y ya está disponible para tus clientes.
              </div>
              <div className="mcc-success-card">
                <img className="mcc-success-img" src={imgpreview} alt={couponName} />
                <div>
                  <div className="mcc-success-name">{couponName}</div>
                  <div className="mcc-success-desc">{description}</div>
                </div>
              </div>
              <button className="mcc-btn-navy" type="button" onClick={handleClose} style={{ minWidth: 140 }}>
                Cerrar
              </button>
              <div style={{ height: '1rem' }} />
            </div>
          )}

          {/* ── FORM ── */}
          {!success && (
            <div className="mcc-body">
              <Form onSubmit={handleFormSubmit}>

                {/* ═══ PASO 1 — Imagen + nombre + descripción ═══ */}
                <div className={`paso ${step === 1 ? "activo" : ""}`}>
                  <div className="mcc-section-head">
                    <span className="mcc-section-label">Imagen y datos del cupón</span>
                    <Info tip="Sube una imagen representativa. El nombre y descripción serán visibles al cliente cuando aplique el cupón." />
                  </div>
                  <div className="mcc-grid-2">
                    {/* imagen */}
                    <div>
                      <div className="mcc-img-upload" title="Clic para seleccionar una imagen" onClick={handleClick}>
                        <img className="mcc-img-preview" src={imgpreview} alt="Preview" />
                        <div className="mcc-img-hint">Clic para cambiar imagen</div>
                      </div>
                      <Form.Group className="mb-3 visually-hidden">
                        <Form.Control
                          type="file" id="upload-button" placeholder="Imagen"
                          name="files" onChange={changeImage} ref={fileInputRef}
                        />
                      </Form.Group>
                    </div>
                    {/* datos */}
                    <div>
                      <div className="mcc-field">
                        <label className="mcc-label">Nombre del cupón</label>
                        <input className="mcc-input" type="text" name="name" placeholder="Ej: Descuento de verano"
                          onChange={e => setCouponName(e.target.value)} value={couponName} />
                      </div>
                      <div className="mcc-field">
                        <label className="mcc-label">Descripción</label>
                        <textarea className="mcc-textarea mcc-input" name="description"
                          placeholder="Describe el beneficio del cupón..." rows={6}
                          onChange={e => setDescription(e.target.value)} value={description} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* ═══ PASO 2 — Tipo de cupón ═══ */}
                <div className={`paso ${step === 2 ? "activo" : ""}`}>
                  <div className="mcc-section-head">
                    <span className="mcc-section-label">Tipo de cupón</span>
                    <Info tip="Define si el descuento aplica a toda la compra o solo a un producto específico. Una vez creado, el tipo no se puede cambiar." />
                  </div>
                  <div className="mcc-radio-grid">
                    <input type="radio" className="mcc-radio-hidden btn-check" name="options-outlined" id="ORDER"
                      autoComplete="off" value="ORDER" checked={cuponType === "ORDER"}
                      onChange={e => { setCuponType(e.target.value); setDiscountType("PERCENTAGE"); setSelectedProducts([]); }}
                    />
                    <label className="mcc-radio-label" htmlFor="ORDER">
                      <div className="mcc-radio-title">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                        Toda la compra
                      </div>
                      <div className="mcc-radio-desc">El descuento se aplica sobre el total del pedido antes de finalizar el pago.</div>
                    </label>

                    <input type="radio" className="mcc-radio-hidden btn-check" name="options-outlined" id="PRODUCT"
                      autoComplete="off" value="PRODUCT" checked={cuponType === "PRODUCT"}
                      onChange={e => { setCuponType(e.target.value); setDiscountType("PERCENTAGE"); setSelectedProducts([]); }}
                    />
                    <label className="mcc-radio-label" htmlFor="PRODUCT">
                      <div className="mcc-radio-title">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
                        Producto específico
                      </div>
                      <div className="mcc-radio-desc">El cupón solo aplica a un artículo seleccionado, sin afectar el resto del pedido.</div>
                    </label>
                  </div>
                </div>

                {/* ═══ PASO 3 — Tipo de descuento ═══ */}
                <div className={`paso ${step === 3 ? "activo" : ""}`}>
                  <Form.Group className="mt-1">
                    <div className="mcc-section-head">
                      <span className="mcc-section-label">Tipo de descuento</span>
                      <Info tip="Porcentaje reduce el precio en %. Monto fijo resta una cantidad exacta en $. Producto gratis solo aplica cuando el cupón es por producto específico." />
                    </div>
                    <div className={`mcc-radio-grid${cuponType === 'PRODUCT' ? ' mcc-radio-grid3' : ''}`}>
                      <input type="radio" className="mcc-radio-hidden btn-check" name="discount_type" id="PERCENTAGE"
                        value="PERCENTAGE" checked={discount_type === "PERCENTAGE"}
                        onChange={e => setDiscountType(e.target.value)}
                      />
                      <label className="mcc-radio-label" htmlFor="PERCENTAGE">
                        <div className="mcc-radio-title">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>
                          Porcentaje
                        </div>
                        <div className="mcc-radio-desc">Descuento proporcional. Ej: 20% de descuento en la compra.</div>
                      </label>

                      <input type="radio" className="mcc-radio-hidden btn-check" name="discount_type" id="FIXED"
                        value="FIXED" checked={discount_type === "FIXED"}
                        onChange={e => setDiscountType(e.target.value)}
                      />
                      <label className="mcc-radio-label" htmlFor="FIXED">
                        <div className="mcc-radio-title">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                          Monto fijo
                        </div>
                        <div className="mcc-radio-desc">Descuento en $. Ej: $5.00 de descuento en cualquier compra.</div>
                      </label>

                      <RenderIf isTrue={cuponType === "PRODUCT"}>
                        <input type="radio" className="mcc-radio-hidden btn-check" name="discount_type" id="FREE_PRODUCT"
                          value="FREE_PRODUCT" checked={discount_type === "FREE_PRODUCT"}
                          onChange={e => setDiscountType(e.target.value)}
                        />
                        <label className="mcc-radio-label" htmlFor="FREE_PRODUCT">
                          <div className="mcc-radio-title">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>
                            Producto gratis
                          </div>
                          <div className="mcc-radio-desc">El cliente obtiene el producto sin costo adicional.</div>
                        </label>
                      </RenderIf>
                    </div>
                  </Form.Group>
                </div>

                {/* ═══ PASO 4 — Valores ═══ */}
                <div className={`paso ${step === 4 ? "activo" : ""}`}>
                  <div className="mcc-section-head">
                    <span className="mcc-section-label">Valores del cupón</span>
                    <Info tip="Define el valor numérico del descuento y, si el cupón es por compra, el monto mínimo requerido y el máximo descuento aplicable." />
                  </div>
                  <div className="mcc-grid-2">
                    <RenderIf isTrue={cuponType === 'ORDER'}>
                      <div className="mcc-field">
                        <label className="mcc-label">Valor mínimo de la orden</label>
                        <input className="mcc-input" type="number" name="min_order_value" placeholder="0.00"
                          onChange={e => setMinOrderValue(e.target.value)} />
                      </div>
                      <div className="mcc-field">
                        <label className="mcc-label">Máximo descuento ($)</label>
                        <input className="mcc-input" type="number" name="max_discount" placeholder="0.00"
                          onChange={e => setMaxDiscount(e.target.value)} />
                      </div>
                    </RenderIf>
                    <RenderIf isTrue={cuponType === 'PRODUCT'}>
                      <div className="mcc-field">
                        <label className="mcc-label">Combos</label>
                        <select className="mcc-select mcc-input"
                          onChange={e => setSelectedProducts(prev => [...prev, { combo_id: e.target.value, is_combo: 1 }])}>
                          <option value={null}>Ninguno seleccionado</option>
                          {combos.map(combo => <option key={combo.id} value={combo.id}>{combo.name}</option>)}
                        </select>
                      </div>
                      <div className="mcc-field">
                        <label className="mcc-label">Productos</label>
                        <select className="mcc-select mcc-input"
                          onChange={e => setSelectedProducts(prev => [...prev, { group_id: e.target.value, is_combo: 0 }])}>
                          <option value={null}>Ninguno seleccionado</option>
                          {groups.map(group => <option key={group.group_id} value={group.group_id}>{group.name}</option>)}
                        </select>
                      </div>
                    </RenderIf>
                  </div>
                  <RenderIf isTrue={discount_type !== "FREE_PRODUCT"}>
                    <div className="mcc-field" style={{ maxWidth: 220 }}>
                      <label className="mcc-label">Valor del descuento {discount_type === 'PERCENTAGE' ? '(%)' : '($)'}</label>
                      <input className="mcc-input" type="number" name="discount_value" placeholder="0.00"
                        onChange={e => setDiscountValue(e.target.value)} />
                    </div>
                  </RenderIf>
                </div>

                {/* ═══ PASO 5 — Fechas y horas ═══ */}
                <div className={`paso ${step === 5 ? "activo" : ""}`}>
                  <div className="mcc-grid-2">
                    {/* fecha expiración */}
                    <div>
                      <div className="mcc-section-head">
                        <span className="mcc-section-label">Fecha de expiración</span>
                        <Info tip="Si activas esto, el cupón dejará de ser válido después de la fecha indicada. Sin fecha, el cupón no expira nunca." />
                      </div>
                      <div className="mcc-toggle">
                        <Form.Check type="switch"
                          label={!showDateLimit ? "Sin fecha límite" : "Con fecha límite"}
                          onChange={e => setShowDateLimit(e.target.checked)}
                        />
                      </div>
                      <RenderIf isTrue={showDateLimit}>
                        <div className="mcc-field" style={{ marginTop: '.6rem' }}>
                          <label className="mcc-label">Fecha de expiración</label>
                          <input className="mcc-input" type="date" name="expiration_date"
                            onChange={e => setExpirationDate(e.target.value)} />
                        </div>
                      </RenderIf>
                    </div>
                    {/* horas */}
                    <div>
                      <div className="mcc-section-head">
                        <span className="mcc-section-label">Rango de horas</span>
                        <Info tip="Restringe el cupón a un horario específico del día. Por ejemplo: válido solo entre 12:00 PM y 3:00 PM (happy hour)." />
                      </div>
                      <div className="mcc-toggle">
                        <Form.Check type="switch"
                          label={!showSpecificHours ? "Todo el día" : "Rango específico"}
                          onChange={e => setShowSpecificHours(e.target.checked)}
                        />
                      </div>
                      <RenderIf isTrue={showSpecificHours}>
                        <div className="mcc-grid-2" style={{ marginTop: '.6rem' }}>
                          <div className="mcc-field">
                            <label className="mcc-label">Hora de inicio</label>
                            <input className="mcc-input" type="time" name="initial_hour"
                              onChange={e => setInitialHour(e.target.value)} />
                          </div>
                          <div className="mcc-field">
                            <label className="mcc-label">Hora límite</label>
                            <input className="mcc-input" type="time" name="expiration_hour"
                              onChange={e => setExpirationHour(e.target.value)} />
                          </div>
                        </div>
                      </RenderIf>
                    </div>
                  </div>
                </div>

                {/* ═══ PASO 6 — Días + límite de uso ═══ */}
                <div className={`paso ${step === 6 ? "activo" : ""}`}>
                  {/* días */}
                  <div style={{ marginBottom: '1rem' }}>
                    <div className="mcc-section-head">
                      <span className="mcc-section-label">Días específicos</span>
                      <Info tip="Activa el cupón solo en ciertos días de la semana. Ideal para promociones de fin de semana o días especiales." />
                    </div>
                    <div className="mcc-toggle">
                      <Form.Check type="switch"
                        label={!showSpecificDays ? "Todos los días" : "Días específicos"}
                        onChange={e => setShowSpecificDays(e.target.checked)}
                      />
                    </div>
                    <RenderIf isTrue={showSpecificDays}>
                      <div className="mcc-days-wrap" style={{ marginTop: '.65rem' }}>
                        {['Lunes','Martes','Miercoles','Jueves','Viernes','Sabado','Domingo'].map(day => (
                          <React.Fragment key={day}>
                            <input type="checkbox" className="mcc-day-input btn-check"
                              name="options-days" id={`opt-day-${day}`}
                              onChange={() => handleDaySelection(day)}
                            />
                            <label className="mcc-day-label" htmlFor={`opt-day-${day}`}>{day}</label>
                          </React.Fragment>
                        ))}
                      </div>
                    </RenderIf>
                  </div>

                  {/* límite de uso */}
                  <div style={{ borderTop: '1px solid var(--border, rgba(0,0,0,.07))', paddingTop: '.85rem' }}>
                    <div className="mcc-section-head">
                      <span className="mcc-section-label">Límite de uso</span>
                      <Info tip="Define cuántas veces puede usar este cupón un mismo cliente. Sin límite, el cliente puede aplicarlo cada vez que compre." />
                    </div>
                    <div className="mcc-toggle">
                      <Form.Check type="switch"
                        label={!hasUsageLimit ? "Sin límite" : "Con límite de usos"}
                        onChange={e => setHasUsageLimit(e.target.checked)}
                      />
                    </div>
                    <RenderIf isTrue={hasUsageLimit}>
                      <div className="mcc-field" style={{ marginTop: '.6rem', maxWidth: 200 }}>
                        <label className="mcc-label">Máx. usos por cliente</label>
                        <input className="mcc-input" type="number" name="usage_limit"
                          placeholder="0" value={usageLimit}
                          onChange={e => setUsageLimit(e.target.value)}
                        />
                      </div>
                    </RenderIf>
                  </div>
                </div>

                {/* ═══ PASO 7 — Códigos únicos + guardar ═══ */}
                <div className={`paso ${step === 7 ? "activo" : ""}`}>
                  {/* códigos únicos */}
                  <div className="mcc-section-head">
                    <span className="mcc-section-label">Códigos únicos</span>
                    <Info tip="Genera códigos individuales de un solo uso. Perfecto para campañas de email o sorteos donde cada cliente recibe un código exclusivo." />
                  </div>
                  <div className="mcc-toggle">
                    <Form.Check type="switch"
                      label={!hasUsageLimit ? "Código genérico" : "Generar códigos únicos"}
                      onChange={e => setNeedsUniqueCodes(e.target.checked)}
                    />
                  </div>
                  <RenderIf isTrue={needsUniqueCodes}>
                    <div className="mcc-field" style={{ marginTop: '.6rem', maxWidth: 220 }}>
                      <label className="mcc-label">Cantidad de códigos</label>
                      <input className="mcc-input" type="number" name="code_count"
                        placeholder="0" value={uniqueCodeQuantity}
                        onChange={e => setUniqueCodeQuantity(e.target.value)}
                      />
                    </div>
                  </RenderIf>

                  {/* resumen previo */}
                  <div style={{ borderTop: '1px solid var(--border, rgba(0,0,0,.07))', paddingTop: '.85rem', marginTop: '.85rem' }}>
                    <div className="mcc-section-head" style={{ marginBottom: '.6rem' }}>
                      <span className="mcc-section-label">Resumen</span>
                    </div>
                    <div className="mcc-summary">
                      <img className="mcc-summary-img" src={imgpreview} alt={couponName} />
                      <div>
                        <div className="mcc-summary-name">{couponName || '—'}</div>
                        <div className="mcc-summary-sub">{description || '—'}</div>
                        <div className="mcc-summary-tag">
                          {cuponType === 'ORDER' ? 'Toda la compra' : 'Producto específico'} · {discount_type}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* submit — función original intacta */}
                  <div className="mt-3 d-flex justify-content-end">
                    <button className="mcc-btn-green" type="submit">
                      <IcoSave /> Guardar Cupón
                    </button>
                  </div>
                </div>

                {/* ═══ navegación ═══ */}
                <div className="mcc-footer">
                  <span className="mcc-step-counter">Paso {step} de {totalSteps}</span>
                  <div className="mcc-footer-btns">
                    <button className="mcc-btn-ghost" type="button" onClick={prevStep} disabled={step === 1}>
                      <IcoBack /> Anterior
                    </button>
                    <button className="mcc-btn-navy" type="button" onClick={nextStep} disabled={step === totalSteps}>
                      Siguiente <IcoNext />
                    </button>
                  </div>
                </div>

              </Form>
            </div>
          )}
          {/* end form */}

        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCreateCupon;